<template>
<div class="chapter">
<div class="inner_page">
<a id="pvi"></a><a id="pvii"></a><a id="pviii"></a><a id="pix"></a>
<blockquote class="sink">
<p class="center "><b>Passager:</b></p>
<p class="center ">A falcon caught in the wild and trained by the falconer, but not yet a mature bird.</p>
</blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front03.vue?a10728d8